exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer{margin:8px}.spacer-v{margin-top:8px;margin-bottom:8px}.spacer-h{margin-left:8px;margin-right:8px}.padder{padding:14px}.padder-v{padding-top:14px;padding-bottom:14px}.padder-h{padding-left:14px;padding-right:14px}", ""]);

// exports
